import Vue from "vue";
/**
 * setting
 * @method setTag
 * @method clearController
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onHidden
 * event
 * @event sendCallbackHidden
 */
export function TermsModalController () {
    this.tag = '',
    this.busModal = new Vue();

    this.callbackHidden = null;

    this.alertModal = null;
    this.noInternetModal = null;

    this.setAlertModal = function (alertModal) {
        this.alertModal = alertModal;
    };
    this.setNoInternetModal = function (noInternetModal) {
        this.noInternetModal = noInternetModal
    };

    //#region setter
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.setTermsContent = function (termsContent) {
        this.termsContent = termsContent
        return this;
    };
    this.clearController = function() {
        this.tag = '';
        this.termsContent = '';
        this.callbackClose = null;

        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            tag: this.tag,
            termsContent: this.termsContent
        };

        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method

    //#region event
    this.onHidden = function(callback) {
        if (typeof callback == 'function') {
            this.callbackHidden = callback;
        }
    };
    this.sendCallbackHidden = function(data) {
        if (typeof this.callbackHidden == 'function') {
            this.callbackHidden(data);
        }
    };
    //#endregion event
}
